//import Moment from "moment";

const getCount = (state) => {
	return state.gruposProduto.length;
}

export default {
	getCount
}